/* eslint-disable react/default-props-match-prop-types, react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import { richSchema } from 'constants/richSchema';

const RichSchemaContainer = React.memo(({ meta }) => {
    const schema = meta?.schemaOrg || richSchema;

    return (
        <script
            data-cmp="richSchema"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, undefined, 4) }}
        />
    );
});

RichSchemaContainer.propTypes = {
    meta: PropTypes.object,
};

export default RichSchemaContainer;
